import { virtualDir } from "#skyward_global";
import { showDialog } from "#skyward_modalLayer";

export function buildAboutPopup()
{
    const options = { width: "15%", transparentGlass: true, draggable: true };

    const aboutPopup = $.ajax(
        {
            url: `${virtualDir}SkySys/About/GetAboutPopup?renderType=contentOnly`
        });
    showDialog("About", aboutPopup, undefined, options);
}